import { Ally } from "../ally/Ally";
import { IInitLocation, Location } from "./Location";

export class Desert extends Location {
}